// Lightweight logger — no-op in production, console.* in development.
//
// Usage:
//   import logger from "@/lib/logger";
//   logger.error("WS connect failed:", err);
//   logger.warn("Beep blocked:", reason);
//   logger.debug("Unread refresh:", payload);
//
// We deliberately keep `error` enabled even in production for true exceptions
// that the user might need to share with support — but everything else is
// stripped so the console stays clean.

const IS_DEV =
  typeof process !== "undefined" &&
  process.env &&
  process.env.NODE_ENV !== "production";

const noop = () => {};

const logger = {
  debug: IS_DEV ? console.debug.bind(console, "[debug]") : noop,
  info: IS_DEV ? console.info.bind(console, "[info]") : noop,
  warn: IS_DEV ? console.warn.bind(console, "[warn]") : noop,
  // Errors are kept in prod too — they're rare and useful for bug reports.
  error: console.error.bind(console, "[error]"),
};

export default logger;
